import { render, staticRenderFns } from "./SfCharacteristic.vue?vue&type=template&id=5be6f5ea&"
import script from "./SfCharacteristic.vue?vue&type=script&lang=js&"
export * from "./SfCharacteristic.vue?vue&type=script&lang=js&"
import style0 from "./SfCharacteristic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports